import React from "react";

/**
 * The signature "Blue" cursive wordmark + diamond mark.
 * size: sm | md | lg | xl
 */
export const BlueLogo = ({
  size = "md",
  showTagline = false,
  stacked = false,
  showBgs = false,
  className = "",
}) => {
  const sizes = {
    sm: { blue: "text-3xl", bgs: "text-lg", tagline: "text-[9px]" },
    md: { blue: "text-5xl", bgs: "text-xl", tagline: "text-[10px]" },
    lg: { blue: "text-7xl", bgs: "text-3xl", tagline: "text-xs" },
    xl: { blue: "text-[9rem] md:text-[13rem]", bgs: "text-5xl", tagline: "text-sm md:text-base" },
  };
  const s = sizes[size];

  return (
    <div className={`inline-flex ${stacked ? "flex-col items-center" : "items-center gap-3"} ${className}`} data-testid="blue-logo">
      <div className="relative inline-flex items-center gap-5">
        <span className={`logo-cursive leading-none ${s.blue}`}>Blue</span>
        <span className="diamond-mark" aria-hidden />
      </div>
      {stacked && (showBgs || showTagline) && (
        <div className="mt-2 flex flex-col items-center">
          {showBgs && (
            <div className={`font-display font-black tracking-[0.15em] text-brand ${s.bgs}`}>BGS</div>
          )}
          {showTagline && (
            <div className={`${showBgs ? "mt-1" : ""} uppercase tracking-[0.35em] text-brand/80 font-semibold ${s.tagline}`}>
              Grading Services
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BlueLogo;
